import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import Dialog from "@material-ui/core/Dialog";
import feedstyles from "src/Assets/css/home/feedpost.module.css";
import sampledialogcancel from "src/Assets/images/Add.png";
import dot from "src/Assets/images/dot.png";
import { blue } from "@material-ui/core/colors";
import { Divider } from "@material-ui/core";
import API from "../../network";
import AvatarBadge from "src/Components/AvatarBadge";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import alreadyImpactfulMemberImg from "src/Assets/images/already_impactful_img.png";
import inviteToBeImapctFullMemberImage from "src/Assets/images/impactful_nominate_img_new.png";
import NominateUser from "../Moderator/ReusableModeratorComponents/NominateUser";

const useStyles = makeStyles({
  avatar: {
    backgroundColor: blue[100],
    color: blue[600],
  },
});

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  maxWidth: 500,
  bgcolor: "background.paper",
  border: "none",
  borderRadius: "20px",
  px: 4,
  py: 2,
  boxShadow: 24,
  zIndex: 4001, // make sure Box content is above Backdrop
};

function SimpleDialog(props) {
  // const classes = useStyles();
  const { onClose, open, isActionDisabled = false, onActionSuccess } = props;
  const userDetails = useSelector((state) => state.SignInReducer.userDetails);

  const communityFollowNames = userDetails?.userData?.communityFollowNames || [];
  const currentTenantId =
    userDetails?.userData?.viewActivityUserTenantInfo?.tenantId;
  const hasFollowedCommunity = communityFollowNames.some(
    (c) =>
      String(c.id) === String(currentTenantId) ||
      String(c.tenantID) === String(currentTenantId) ||
      String(c.tenantId) === String(currentTenantId)
  );
  const isPrivate =
    isActionDisabled ||
    String(
      userDetails?.userData?.viewActivityUserTenantInfo?.communityType
    ).toLowerCase() === "private";
  const isNominateDisabled = isActionDisabled || (isPrivate && !hasFollowedCommunity);

  const handleClose = () => {
    onClose(false);
  };

  var profileImagePath = process.env.REACT_APP_SKOPIC_IMAGE;

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      aria-describedby="modal-modal-description"
      key={`simpleDialog${props.id}`}
      sx={{
        zIndex: 4000,
      }}
    >
      <Box sx={style} className={feedstyles.materialdialog}>
        {props.Followers ? (
          <div className={feedstyles.sampledialogcountandcancel}>
            <p className={feedstyles.sampledialogtotalcount}>
              <b>{props.Followers} following</b>
            </p>
            <a onClick={handleClose}>
              <img
                src={sampledialogcancel}
                style={{
                  // backgroundColor: "#F3F2F0",
                  borderRadius: "50%",
                  padding: "8%",
                }}
              />
            </a>
          </div>
        ) : (
          <div className={feedstyles.sampledialogcountandcancel}>
            <p className={feedstyles.sampledialogtotalcount}>
              {props.likes === 1 ? (
                <b>{props.likes} Like</b>
              ) : (
                <b>{props.likes} likes</b>
              )}
            </p>
            <a onClick={handleClose}>
              <img src={sampledialogcancel} />
            </a>
          </div>
        )}
        <div className={feedstyles.followersList}>
          {props.followersData ? (
            props.followersData.map((followersresult, index) => (
              <>
                <div
                  key={`followersData${index}${followersresult?.saycount}`}
                  className={feedstyles.followersmodal}
                >
                  <AvatarBadge
                    src={`${profileImagePath}${followersresult.uimage}`}
                    className={feedstyles.sampledialogvatar}
                    size={50}
                    isPrimaryModerator={followersresult.isPM == 1}
                    isModerator={
                      followersresult.isModerator == 1 &&
                      followersresult.isPM == 0
                    }
                  />
                  <div style={{ marginLeft: "10px" }}>
                    <span className={feedstyles.profilename}>
                      {followersresult?.displayName}
                      {(followersresult?.isImpactableMember === "yes" ||
                        followersresult?.mainuserdata?.isImpactableMember === "yes") && (
                        <img
                          src={alreadyImpactfulMemberImg}
                          alt="Impactful Member"
                          title="Impactful Member"
                          style={{
                            width: "18px",
                            height: "18px",
                            objectFit: "contain",
                            flexShrink: 0,
                            marginLeft: "5px",
                          }}
                        />
                      )}
                    </span>
                    <p className={feedstyles.sampledialgoxtext}>
                      ASK {followersresult.askcount} | SAY{" "}
                      {followersresult.saycount} | UPDATE{" "}
                      {followersresult.updatecount} | TAG{" "}
                      {followersresult.hashtagcount} | Answers{" "}
                      {followersresult.answercount} | Replies{" "}
                      {followersresult.replycount}
                    </p>
                  </div>
                  {followersresult?.userid !==
                    userDetails?.userData?.User_ID && (
                    !userDetails?.userData?.User_ID ? (
                      <button
                        type="button"
                        disabled
                        style={{
                          padding: 0,
                          margin: 0,
                          border: "none",
                          background: "transparent",
                          cursor: "default",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          outline: "none",
                          pointerEvents: "none",
                        }}
                      >
                        <img
                          src={inviteToBeImapctFullMemberImage}
                          alt="Invite"
                          style={{
                            width: "23px",
                            height: "23px",
                            objectFit: "contain",
                            display: "block",
                          }}
                        />
                      </button>
                    ) : (
                      <NominateUser
                        result={followersresult}
                        disabled={isNominateDisabled}
                        onActionSuccess={onActionSuccess}
                      >
                        <button
                          type="button"
                          style={{
                            padding: 0,
                            margin: 0,
                            border: "none",
                            background: "transparent",
                            cursor: isNominateDisabled ? "not-allowed" : "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            outline: "none",
                          }}
                        >
                          <img
                            src={inviteToBeImapctFullMemberImage}
                            alt="Invite"
                            title={isNominateDisabled ? "Follow community to nominate" : "Nominate as Impactful Member"}
                            style={{
                              width: "23px",
                              height: "23px",
                              objectFit: "contain",
                              display: "block",
                            }}
                          />
                        </button>
                      </NominateUser>
                    )
                  )}
                  {/* <Divider/> */}
                </div>
                <Divider className={feedstyles.divider} />
              </>
            ))
          ) : props.likesData ? (
            props.likesData.map((likesresult, index) => (
              <>
                <div
                  key={`likesData${index}${likesresult?.saycount}`}
                  className={feedstyles.followersmodal}
                >
                  <AvatarBadge
                    src={`${profileImagePath}${likesresult.uimage}`}
                    className={feedstyles.sampledialogvatar}
                    size={50}
                    isPrimaryModerator={likesresult.isPM == 1}
                    isModerator={
                      likesresult.isModerator == 1 && likesresult.isPM == 0
                    }
                  />
                  <div style={{ marginLeft: "10px" }}>
                    <span className={feedstyles.profilename}>
                      {likesresult?.displayName}
                      {(likesresult?.isImpactableMember === "yes" ||
                        likesresult?.mainuserdata?.isImpactableMember === "yes") && (
                        <img
                          src={alreadyImpactfulMemberImg}
                          alt="Impactful Member"
                          title="Impactful Member"
                          style={{
                            width: "18px",
                            height: "18px",
                            objectFit: "contain",
                            flexShrink: 0,
                            marginLeft: "5px",
                          }}
                        />
                      )}
                    </span>
                    <p className={feedstyles.sampledialgoxtext}>
                      ASK {likesresult.askcount} | SAY {likesresult.saycount} |
                      UPDATE {likesresult.updatecount} | TAG{" "}
                      {likesresult.hashtagcount} | Answers{" "}
                      {likesresult.answercount} | Replies{" "}
                      {likesresult.replycount}
                    </p>
                  </div>
                  {likesresult?.userid !== userDetails?.userData?.User_ID && (
                    !userDetails?.userData?.User_ID ? (
                      <button
                        type="button"
                        disabled
                        style={{
                          padding: 0,
                          margin: 0,
                          border: "none",
                          background: "transparent",
                          cursor: "default",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          outline: "none",
                          pointerEvents: "none",
                        }}
                      >
                        <img
                          src={inviteToBeImapctFullMemberImage}
                          alt="Invite"
                          style={{
                            width: "23px",
                            height: "23px",
                            objectFit: "contain",
                            display: "block",
                          }}
                        />
                      </button>
                    ) : (
                      <NominateUser
                        result={likesresult}
                        disabled={isNominateDisabled}
                        onActionSuccess={onActionSuccess}
                      >
                        <button
                          type="button"
                          style={{
                            padding: 0,
                            margin: 0,
                            border: "none",
                            background: "transparent",
                            cursor: isNominateDisabled ? "not-allowed" : "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            outline: "none",
                          }}
                        >
                          <img
                            src={inviteToBeImapctFullMemberImage}
                            alt="Invite"
                            title={isNominateDisabled ? "Follow community to nominate" : "Nominate as Impactful Member"}
                            style={{
                              width: "23px",
                              height: "23px",
                              objectFit: "contain",
                              display: "block",
                            }}
                          />
                        </button>
                      </NominateUser>
                    )
                  )}
                  {/* <Divider/> */}
                </div>
                <Divider className={feedstyles.divider} />
              </>
            ))
          ) : (
            <span>NO Data</span>
          )}
        </div>
      </Box>
    </Modal>
  );
}

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default function SimpleDialogDemo(props) {
  // const followerCountData = useSelector(
  //   (state) => state.followReducer.FollowerCountData
  // );
  const [followerCountData, setFollowerCountData] = useState(0);

  // const [isCountData, setCountData] = useState(props.voteUp);
  // const [isFollowCountData, setFollowCountData] = useState(props.followCount);

  // useEffect(() => {
  //         // if (props.isVoteup==="1") {
  //         //     setCountData(isCountData + 1)
  //         // }
  //         // console.log(props.isVoteup)
  // if(props.isFollow==="followed")
  // {
  //     setFollowCountData(isFollowCountData+1)
  // }
  //     else if(props.isFollow==="followed"{
  //         setFollowCountData(isFollowCountData-1)
  //     }
  // console.log(isFollowCountData)
  // }, []);
  // console.log(followerCountData)
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = async (id, type) => {
    setOpen(true);
    // dispatch(feedactions.fetchFollowerCount(id, type));
    const response = await API.fetchFollowerCount(id, type);
    if (response) {
      setFollowerCountData(response.data);
    }
  };

  const handleClose = () => {
    setOpen(false);
    // setCountData(prev=>prev+1)
  };

  return (
    <div key={`followerorlikes${props.id}`}>
      {props.followCount || props.followCount === 0 ? (
        <a
          onClick={() => {
            if (props.followCount > 0) {
              handleClickOpen(props.id, "follow");
            }
          }}
          // id={props.id}
          className={feedstyles.followerbgcolor}
        >
          {props.followCount === 1
            ? `${props.followCount} follower`
            : `${props.followCount} followers`}
        </a>
      ) : (
        <a
          variant="outlined"
          // color="primary"
          onClick={() => {
            if (props.voteUp > 0) handleClickOpen(props.id, "like");
          }}
          // id={props.id}
          className={feedstyles.followerbgcolor}
        >
          {props.voteUp === 1
            ? `${props.voteUp} like`
            : `${props.voteUp} likes`}
        </a>
      )}

      {props.hashTagType === "private" && (
        <span className={feedstyles.hashTagType}>
          <span>
            <img src={dot} alt="dot" />
          </span>{" "}
          Private
        </span>
      )}

      {!!followerCountData && Object.keys(followerCountData).length !== 0 && (
        <SimpleDialog
          open={open}
          onClose={handleClose}
          Followers={props.followCount}
          followersData={followerCountData.follweduserprofile}
          key={props.id}
          likes={props.voteUp}
          likesData={followerCountData.likeduserprofile}
          isActionDisabled={props.isActionDisabled}
          onActionSuccess={props.onActionSuccess}
        />
      )}
    </div>
  );
}
